<template>
  <dialog open :aria-labelledby="idTitle" :aria-describedby="idContent" class="eb-dialog fixed flex flex-col text-center align-items-center" :class="{'eb-dialog-destructive': type ==='destructive'}" @keydown="keyPress" :role="type =='destructive'?'alertdialog':'dialog'">
    <font-awesome-layers class="fa-3x fa-fw">
      <font-awesome-icon icon="circle" size="2x" />
      <font-awesome-icon v-if="type =='destructive'" :icon="['fas', 'trash-alt']" transform="shrink-6" :style="{ color: 'white' }" />
      <font-awesome-icon v-else :icon="['fas', 'lightbulb']" transform="shrink-6" :style="{ color: 'white' }" />
    </font-awesome-layers>
    
    <EbHeading level="h3" class="eb-dialog-title" :id="idTitle">{{title}}</EbHeading>
    <p class="eb-dialog-text" :id="idContent">{{text}}</p>
    <div v-if="type =='destructive'" class="eb-button-group">
      <EbButton type="button" hierarchy="secondary" @click='close'>Je conserve</EbButton>
      <EbButton type="button" hierarchy="destructive" @click="accepted">Oui, je supprime</EbButton>
    </div>
    <EbButton v-else type="button" @click="close">Fermer</EbButton>
  </dialog>
</template>

<script>
export default {
  name: "EbModal",
  props: {
    type: {
      type: String,
      default: "default",
      validator: (value) => {
        return value.match(/(default|destructive)/);
      },
    },
    title: {
      type: String,
      default: 'titre'
    },
    text: {
      type: String,
      default: 'text'
    }
  },
  data() {
    return {
      backdrop: document.createElement('div'),
      previousFocus: null,
      
      focusableElements: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    }
  },
  computed: {
    idTitle: function() {
      return `title_${this.id}`
    },
    idContent: function() {
      return `content_${this.id}`
    },
    modal: function() {
      return this.$el
    },
    id: function() {
      return this._uid
    },
    firstFocusableElement: function() {
      return this.modal.querySelectorAll(this.focusableElements)[0]
    },
    focusableContent: function() {
      return this.modal.querySelectorAll(this.focusableElements)
    },
    lastFocusableElement: function() {
      return this.focusableContent[this.focusableContent.length - 1]
    }
  },
  mounted() {
    this.previousFocus = document.activeElement
    this.backdrop.classList.add('backdrop')
    this.modal.parentNode.insertBefore(this.backdrop,this.modal)
    this.firstFocusableElement.focus()
  },
  beforeDestroy() {
    this.previousFocus.focus()
    this.backdrop.parentNode.removeChild(this.backdrop)
  },
  methods: {
    close: function() {
      this.$emit('close',true)
    },
    accepted: function() {
      this.$emit('validate',true)
    },
    keyPress: function(e) {
      const isTabPressed = e.key === 'Tab' || e.keyCode === 9,
      isEscPressed = e.key === 'Esc' || e.key === 'Escape' || e.keyCode === 27;
      
      if (!isTabPressed && !isEscPressed) {
        return;
      }
      
      if(isEscPressed) {
        this.close()
        e.preventDefault();
      }
      
      if (e.shiftKey) {
        if (document.activeElement === this.firstFocusableElement) {
          this.lastFocusableElement.focus();
          e.preventDefault();
        }
      }
      else {
        if (document.activeElement === this.lastFocusableElement) {
          this.firstFocusableElement.focus();
          e.preventDefault();
        }
      }
    }
  }
}
</script>

<style lang="scss">
.eb-dialog {
  @include inset-space($eb-space-l);
  border: 0;
  border-radius: $eb-radius-m;
  box-shadow: box-shadow-size($eb-elevation-aerien);
  z-index: $eb-zindex-modal;
  font-size: $eb-font-size-default;
  
  &-title {
    margin-top: $eb-space-m;
    margin-bottom: $eb-space-s;
    font-weight: $eb-font-weight-semibold;
    text-transform: uppercase;
    font-size: $eb-font-size-default;
  }
  
  &-text {
    color: $eb-color-gray-700;
  }
  
  &-destructive {
    border-top: $eb-border-xxl solid $eb-color-error;
    & .svg-inline--fa {
      color:$eb-color-error;
    }
  }
  
  @include respond-to("medium") {
    height: 100vh;
    position: absolute;
    top: 0;
    left: 0;
  }
}

::backdrop {
  @include HEXtoRGBA(background-color, $eb-color-blue-primary, .6);
}

.backdrop {
  @include HEXtoRGBA(background-color, $eb-color-blue-primary, .6);
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: $eb-zindex-modal - 1;
}
</style>